import Turntable from "./Turntable/index.vue";
import RewardModal from "@/components/UI/RewardModal/index.vue";
import CaseOpening from "@/components/UI/CaseOpening/index.vue";
import CaseOpeningMore from "@/components/UI/CaseOpening/more.vue";
import Award from "@/components/UI/award/index.vue";
import CaseImg from "@/components/UI/CaseImg.vue";



export {
    Turntable,
    RewardModal,
    CaseOpening,
    CaseOpeningMore,
    Award,
    CaseImg
}